declare const moxyDateStringBrand: unique symbol;

/** A DateAdapter-compatible JSON value: yyyy-MM-dd'T'HH:mm:ssZ. */
export type MoxyDateString = string & { readonly [moxyDateStringBrand]: true };

/**
 * Preserve the user-selected calendar date and encode it for OCC's MOXy DateAdapter.
 * Native JSON.stringify(Date) is not compatible because it emits milliseconds.
 */
export function toMoxyDate(date: Date): MoxyDateString {
  if (Number.isNaN(date.getTime())) {
    throw new RangeError("Cannot encode an invalid Date for MOXy");
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00:00+0000` as MoxyDateString;
}

export function toMoxyDateFromCalendarDate(value: string): MoxyDateString {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  const date = match ? new Date(`${value}T00:00:00Z`) : new Date(NaN);
  if (
    !match ||
    Number.isNaN(date.getTime()) ||
    date.getUTCFullYear() !== Number(match[1]) ||
    date.getUTCMonth() + 1 !== Number(match[2]) ||
    date.getUTCDate() !== Number(match[3])
  ) {
    throw new RangeError("Cannot encode an invalid calendar date for MOXy");
  }

  return `${value}T00:00:00+0000` as MoxyDateString;
}

export function toMoxyDateNullable(date: Date | null | undefined): MoxyDateString | null {
  return date ? toMoxyDate(date) : null;
}
